import type {
  CreateUserRequest,
  CreateUserResponse,
  ListUsersQuery,
  ListUsersResponse,
  ResetPasswordResponse,
  UpdateUserRequest,
  UserDetails,
} from '@kreart/shared';
import { api } from '@/lib/api';

/**
 * Serialise list query into stable search params. Default values are OMITTED so
 * the query cache and URLs stay normalised (no `?page=1&pageSize=25&includeDeleted=false`).
 */
export function serialiseListQuery(query: ListUsersQuery): string {
  const p = new URLSearchParams();
  if (query.page !== 1) p.set('page', String(query.page));
  if (query.pageSize !== 25) p.set('pageSize', String(query.pageSize));
  if (query.search) p.set('search', query.search);
  if (query.role) p.set('role', query.role);
  if (query.active !== undefined) p.set('active', String(query.active));
  if (query.includeDeleted) p.set('includeDeleted', 'true');
  const qs = p.toString();
  return qs ? `?${qs}` : '';
}

export const usersApi = {
  list: (query: ListUsersQuery) => api.get<ListUsersResponse>(`/users${serialiseListQuery(query)}`),
  get: (id: string) => api.get<UserDetails>(`/users/${id}`),
  create: (body: CreateUserRequest) => api.post<CreateUserResponse>('/users', body),
  update: (id: string, body: UpdateUserRequest) => api.patch<UserDetails>(`/users/${id}`, body),
  resetPassword: (id: string) =>
    api.post<ResetPasswordResponse>(`/users/${id}/reset-password`, undefined),
  remove: (id: string) => api.delete<void>(`/users/${id}`),
};
